import React from 'react'
import PropTypes from 'prop-types'

export default function BreakOnBr ({ text }) {
  if (!text || !text.split) {
    return text
  }

  const pieces = []
  let i = 0

  text.split(/<br[^>]*>/).forEach(piece => {
    if (pieces.length > 0) {
      pieces.push(<br key={`break-${i}`} />)
    }
    pieces.push(<span key={`text-${i}`}>{piece.trim()}</span>)
    i += 1
  })

  return <span>{pieces}</span>
}

BreakOnBr.propTypes = {
  text: PropTypes.string
}
